import { useProject } from 'context/ProjectContext'
import { useEffect, useState } from 'react'
import TaskService from 'services/TaskService'
import { socketEventEmitter } from '../socket'
import { TASK_STATUSES, TASK_TYPES, TASK_ALIAS_TYPES } from '../constants'

export default function usePageTasksStatus({ page }) {

    const { selectedProject } = useProject()

    const [isUiScanInProgress, setIsUiScanInProgress] = useState(false)
    const [isGenerateTestsInProgress, setIsGenerateTestsInProgress] = useState(false)


    useEffect(() => {
        if (!page) {
            return;
        }

        const fetchData = async () => {
            try {
                const res = await TaskService.getAllTasksByProjectId(
                    selectedProject?.id,
                );
                res.tasks.forEach((task) => {
                    const isTaskForCurrentPage = task.page_id === page.page.id;
                    const isTaskInProgressOrPending =
                        task.status === TASK_STATUSES.IN_PROGRESS ||
                        task.status === TASK_STATUSES.PENDING;

                    if (!isTaskForCurrentPage || !isTaskInProgressOrPending) {
                        return;
                    }

                    if (task.task_type === TASK_TYPES.TEST_CASE_DISCOVERY) {
                        setIsGenerateTestsInProgress(true);
                        return;
                    }

                    if (task.task_type === TASK_TYPES.UI_SCAN) {
                        setIsUiScanInProgress(true);
                        return;
                    }
                })
            } catch (error) {
                console.error('Error fetching tasks:', error);
            }
        }

        fetchData();

    }, [selectedProject?.id, page])


    useEffect(() => {
        if (!page) {
            return;
        }

        const changeStatus = (type, status) => {
            if (
                type === TASK_TYPES.TEST_CASE_DISCOVERY ||
                type === TASK_ALIAS_TYPES.DISCOVER_TEST_CASES
            ) {
                setIsGenerateTestsInProgress(status);
                return;
            } 
            
            if (
                type === TASK_TYPES.UI_SCAN ||
                type === TASK_ALIAS_TYPES.SCAN
            ) {
                setIsUiScanInProgress(status);
                return;
            }
        }

        const startProgress = ({ type, pageId }) => {
            if (pageId !== page.page.id) {
                return;
            }
            changeStatus(type, true);
        }

        const stopProgress = ({ type, pageId }) => {
            if (pageId !== page.page.id) {
                return;
            }

            changeStatus(type, false);
        }

        socketEventEmitter.on('taskCompleted', stopProgress);
        socketEventEmitter.on('taskFailed', stopProgress);
        socketEventEmitter.on('newTaskAdded', startProgress);

        return () => {
            socketEventEmitter.off('taskCompleted', stopProgress);
            socketEventEmitter.off('taskFailed', stopProgress);
            socketEventEmitter.off('newTaskAdded', startProgress);

        }
    }, [selectedProject?.id, page])

    return {
        isUiScanInProgress,
        isGenerateTestsInProgress
    }
}
